if (!customElements.get('faq-accordion')) {
  class FaqAccordion extends HTMLElement {

    constructor() {
      super()
    }

    connectedCallback() {
      this.attachEvents()
    }

    attachEvents() {
      window.addEventListener('load', () => {
        this.close()
      });
    }

    close() {
      this.querySelector('details').removeAttribute('open');
    }

    open() {
      this.querySelector('details').setAttribute('open', true);
    }

  }

  customElements.define('faq-accordion', FaqAccordion)
}
